import React from 'react'

export const EditIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `mask0_${Date.now()}`)
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='2'
        y='2'
        width='20'
        height='20'
      >
        <rect x='2' y='2' width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M6.49935 17.5001H7.4256L15.6227 9.303L14.6964 8.37675L6.49935 16.5738V17.5001ZM5.41602 18.5834V16.1172L15.7831 5.73404C15.8952 5.61959 16.0158 5.53814 16.145 5.48966C16.2741 5.44105 16.4095 5.41675 16.551 5.41675C16.6927 5.41675 16.8279 5.43946 16.9566 5.48487C17.0855 5.53029 17.2103 5.61071 17.331 5.72612L18.2654 6.65237C18.3808 6.77307 18.4625 6.89807 18.5106 7.02737C18.5587 7.15668 18.5827 7.2898 18.5827 7.42675C18.5827 7.57272 18.5574 7.71203 18.5068 7.84466C18.4562 7.9773 18.3757 8.09855 18.2654 8.20841L7.88227 18.5834H5.41602ZM15.1514 8.848L14.6964 8.37675L15.6227 9.303L15.1514 8.848Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}
